"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submittalDocumentTypes = void 0;
exports.submittalDocumentTypes = new Set([
    { value: 'Submittal', text: 'Submittal' },
    { value: 'Transmittal', text: 'Transmittal' },
]);
